import clsx from "clsx";
import { Fragment, useMemo } from "react";
import LTSBetButton from "src/components/bet-button/lts-bet-button";
import { useAppSelector } from "src/redux/redux-hooks";
import { MarketFancyI } from "src/types/eventDetail";
import { findMarketLimit, formatAmount, getIsBallRunning, getIsSuspended } from "src/utils/functions";

interface TProps {
  list: MarketFancyI[];
  eventExposure: any;
  onBetLockClick?: () => void;
}

const FancyMarkets = ({ list, eventExposure, onBetLockClick }: TProps) => {
 

  return (
    <Fragment>
      <div className="market-6">
        <div className="bet-table">
          <div className="bet-table-header">
            <div data-toggle="collapse" data-target="#market1" aria-expanded="true" className="nation-name">
              <span title="Normal"> Normal </span>
            </div>
            <div className="float-right">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onBetLockClick?.();
                }}
                className="btn btn-back"
              >
                Bet Lock
              </a>
            </div>
          </div>
          <div id="market1" data-title="OPEN" className="bet-table-body collapse show">
            <div className="bet-table-row">
              <div className="text-right nation-name"></div>
              <div className="lay bl-title d-none-mobile">No</div>
              <div className="back bl-title d-none-mobile">Yes</div>
            </div>
            {Array.isArray(list) &&
              list.map((fancy, index) => {
                const mExposure: any = eventExposure?.fancyMarkets?.find(
                  (item: any) => item.provider_market_id === fancy.provider_market_id
                );

                return (
                  <FancyMarketRow key={index + fancy.provider_market_id} market={fancy} marketExposure={mExposure} />
                );
              })}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

interface Props {
  market: MarketFancyI;
  marketExposure?: any;
}

const FancyMarketRow = ({ market, marketExposure }: Props) => {
  const { userData } = useAppSelector((state) => state.user);
  const isSuspended = getIsSuspended({ providerStatus: market?.provider_status });
  const isBallRunning = getIsBallRunning({ providerStatus: market?.provider_status });

  const marketLimit = useMemo(() => {
    const marketLimit = findMarketLimit({
      market_limits: market?.market_limits,
      currency_id: userData?.currency_id,
    });

    return marketLimit;
  }, [market?.market_limits, userData?.currency_id]);

  const min = marketLimit?.min ? formatAmount({ amt: marketLimit.min.toString() }).value : null;
  const max = marketLimit?.max ? formatAmount({ amt: marketLimit.max.toString() }).value : null;

  return (
    <div className="fancy-tripple">
      <div
        data-title={market?.provider_status.split("_").join(" ")}
        className={clsx("bet-table-row", {
          suspendedfull: isBallRunning || isSuspended,
        })}
      >
        <div className="nation-name d-none-mobile">
          <p>{market.market_name}</p>
          <p
            className="mb-0"
            style={{ color: marketExposure?.amount && marketExposure?.amount <= 0 ? "red" : "green" }}
          >
            {marketExposure?.amount ?? 0}
          </p>
        </div>

        <LTSBetButton
          type="lay"
          index={"1"}
          odds={market.no_value}
          size={market.no_rate}
          fancyMarket={market}
          // event={event as any}
          curMarketExposure={[]}
        />
        <LTSBetButton
          type="back"
          index={"1"}
          odds={market.yes_value}
          size={market.yes_rate}
          fancyMarket={market}
          // event={event as any}
          curMarketExposure={[]}
        />

        <div className="fancy-min-max">
          {min && <span>Min: {min}</span>} {max && <span>Max: {max}</span>}
        </div>
      </div>
    </div>
  );
};

export default FancyMarkets;
